module.exports = __webpack_public_path__ + "img/bl.7456ba66.png";